/**
 * Jemné vysvětlivky: malá info tečka, po najetí/fokusu zobrazí krátký
 * popover „co to dělá a kdy to použít". Nerušivé, přístupné (button
 * s aria-label, popover role=tooltip, otevírá se i klávesnicí).
 */
import { activeParams, type Store } from '../state/store';
import { el } from './dom';
import { icon } from './icons';

let tipEl: HTMLElement | null = null;
let hideTimer: number | undefined;

function showTip(anchor: HTMLElement, text: string): void {
  hideTip();
  tipEl = el('div', { className: 'help-tip', role: 'tooltip' }, text);
  document.body.appendChild(tipEl);
  const r = anchor.getBoundingClientRect();
  const tw = Math.min(280, window.innerWidth - 24);
  tipEl.style.maxWidth = `${tw}px`;
  const tr = tipEl.getBoundingClientRect();
  let left = r.left + r.width / 2 - tr.width / 2;
  left = Math.max(8, Math.min(window.innerWidth - tr.width - 8, left));
  let top = r.bottom + 6;
  if (top + tr.height > window.innerHeight - 8) top = r.top - tr.height - 6;
  tipEl.style.left = `${Math.round(left)}px`;
  tipEl.style.top = `${Math.round(top)}px`;
}

function hideTip(): void {
  if (hideTimer !== undefined) window.clearTimeout(hideTimer);
  tipEl?.remove();
  tipEl = null;
}

/**
 * Info tečka s vysvětlivkou. Respektuje parametr „ui.showHints" —
 * při vypnutí vrací prázdný span (layout se nerozbije).
 */
export function infoDot(store: Store, text: string): HTMLElement {
  if (!activeParams(store.get()).get('ui.showHints')) {
    return el('span', { className: 'help-dot--off', 'aria-hidden': 'true' });
  }
  const btn = el(
    'button',
    {
      className: 'help-dot',
      type: 'button',
      'aria-label': `Nápověda: ${text}`,
    },
    icon('info', { size: 13 }),
  ) as HTMLButtonElement;
  btn.addEventListener('mouseenter', () => showTip(btn, text));
  btn.addEventListener('mouseleave', () => {
    hideTimer = window.setTimeout(hideTip, 120);
  });
  btn.addEventListener('focus', () => showTip(btn, text));
  btn.addEventListener('blur', hideTip);
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    if (tipEl) hideTip();
    else showTip(btn, text);
  });
  return btn;
}
